export default "__VITE_ASSET__jyvUhB_F__"